import React from 'react';
import { useLocation } from 'react-router-dom';
import { Col, Row, Container } from 'reactstrap';
// import logo from '../../images/logo-full.png';

import { Layout, PageTitle, FormGroup, Input, PillButton, PreLoader } from '../../components';
import useChangePassword from '../../providers/Customer/useChangePassword';

function Login() {
  const { search } = useLocation();
  const token = new URLSearchParams(search).get('key');

  const {
    form: { password },
    _v,
    loading,
    handleSubmit,
  } = useChangePassword({ token });
  return (
    <Layout>
      <PageTitle pageName="login-page" title="Login" />
      <div className="contact login-page-content pb-5 mb-5">
        <Container>
          <div className="row justify-content-center">
            <Col lg={6}>
              <div className="login-page-outer">
                <div className="login-form-outer">
                  <div className="section-title text-center">
                    {/* <img src={logo} alt="Browncon Investing" width="240" className="mb-5" /> */}

                    <h2>
                      {/* Sign Up To<span> Browncon Investing</span> */}
                      Set A <span>New Password</span>
                    </h2>
                  </div>
                </div>
                <form className="contact-form" onSubmit={handleSubmit}>
                  <Row>
                    <Col xl={12} lg={12}>
                      <FormGroup>
                        <Input
                          id="password"
                          required
                          {...password(_v.newPassword)}
                          placeholder="Enter Your New Password"
                          label="New Password"
                        />
                      </FormGroup>
                    </Col>
                    <Col xl={12} lg={12}>
                      <FormGroup>
                        <Input
                          id="confirm-password"
                          required
                          {...password(_v.confirmPassword)}
                          placeholder="Re-Enter Your Password"
                          label="Confirm Password"
                        />
                      </FormGroup>
                    </Col>
                    <Col xl={12} lg={12}>
                      <Row className="d-flex">
                        <Col className="text-center" xl={6} lg={6}>
                          {loading ? (
                            <PreLoader />
                          ) : (
                            <PillButton className="login-button" label="Update" type="submit" />
                          )}
                        </Col>
                        {/* <Col xl={6} lg={6} className="d-flex align-items-center">
                          <Link to={routes.login} className="forgetting-password">
                            Forgot Password?
                          </Link>
                        </Col> */}
                      </Row>
                    </Col>
                  </Row>
                </form>
              </div>
            </Col>
          </div>
        </Container>
      </div>
    </Layout>
  );
}

export default Login;
